import { render, staticRenderFns } from "./file-field.vue?vue&type=template&id=a572ccc2&scoped=true&lang=pug"
import script from "./file-field.vue?vue&type=script&lang=js"
export * from "./file-field.vue?vue&type=script&lang=js"
import style0 from "./file-field.vue?vue&type=style&index=0&id=a572ccc2&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a572ccc2",
  null
  
)

export default component.exports